import { GET_ACTIVE_OR_MOST_RECENT_ASSIGNMENT_FOR_CONTACT_QUERY } from '../__generated__/chirp/com/hubspot/prospecting/agent/rpc/ContactAssignmentService.dfc.new';
// This function can be called in a card registry in order to fire a request
// before your JS has loaded and evaluated.
export const dataResolver = ({
  graphqlClient: __graphqlClient,
  dfcClient
}, {
  cardData: __cardData,
  additionalLocationData: {
    objectId,
    objectTypeId
  }
}) => {
  if (!objectId || objectTypeId !== '0-1') {
    return Promise.resolve({
      assignment: null
    });
  }
  return dfcClient.query({
    query: GET_ACTIVE_OR_MOST_RECENT_ASSIGNMENT_FOR_CONTACT_QUERY,
    variables: {
      contactId: objectId
    }
  }).then(({
    data
  }) => {
    return {
      assignment: data.result
    };
  });
};